import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border border-border bg-bg px-3 py-2 text-sm text-fg outline-none transition',
        'placeholder:text-fg-muted',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-fg',
        'focus:border-brand focus:ring-2 focus:ring-brand/20',
        'disabled:cursor-not-allowed disabled:bg-bg-subtle disabled:opacity-60',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:focus:border-danger aria-[invalid=true]:focus:ring-danger/20',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
